import IndustryField from "./IndustryField"

export default IndustryField
